import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PDFComplexViewV4 } from 'dsilo-ui-components';
import {
    clearSuccessMsg,
    downloadContractPDFAction,
    downloadSheet,
    getContractDataById,
    getEventByID,
    updateContractAnnotations,
    getDataModelById,
    getModelData,
    getModelDataDropDown,
    initiateAction,
    updateDataModelData,
    getMembersList,
    clearReduxDataOfCurrentComponent,
    getAuditTrailsData,
    completeReviewAction,
    getDataModels,
    otherDocMove,
    supportingDocMove,
    getHistoryData,
    getWorkflow,
    getGroupsByMemberId,
    getNextRespondent,
    getNextTasks,
    reInitiateWorkflow,
    executeWorkFlow,
    executeWorkFlowReject,
    changeAssigneeRequest,
    addComment,
    rejectReviewAction,
    getGroups,
    fetchmasterDataForDataelementUsingRules,
    createDocumentTableData,
    getDocumentTablesDataById,
    updateDocumentTableData,
    deleteDocumentTableData,
    moveToDuplicates,
    getLineItemsTablesData,
    addNewEntriesByDataModel,
    createAmendment,
    getAmendments,
    createContractHierarchy,
    getContractHierarchys,
    deleteTreeElements,
    createNewDocumentPrompt,
    getDocumentQuestions,
    getSupportingDocuments,
    uploadSupportDocument,
    emailSendNotification,
    splitPDF,
    getDocumentHierarchys,
    updateDocHierarchys,
    getDocumentHierarchysV2,
    uploadAttachmentAmendmentTemplate,
    createAmendmentV2,
    getSubModelData,
    getPDFForOtherDoc,
    getPDFForAllOtherDoc,
    getPDFForSupportingDocuments,
    getDocumentQuestionsHierarchy,
    getCurrentStepRespondents,
    userActivityRecordEvent,
    uploadLITableExcel,
    getOthersAuditTrailsData
} from '../../store/actions';
import { Loader } from '../loader';
import { PUBLIC_PATH } from '../../constants';

const PDFComplexViewV4Component = props => {
    // To avoid unwanted popups on list pages (when redirecting to list page from view page)
    useEffect(() => {
        return () => {
            props.clearReduxDataOfCurrentComponent({
                key: "message",
                subKey: []
            })
        }
    }, [])

    return (
        <div>
            <PDFComplexViewV4
                {...props}
                env={process.env}
                loader={<Loader />}
                jwtAuthToken={localStorage.getItem('jwt_access_token') || ''}
                isNewV1Theme={props.isNewV1Theme}
            />
        </div>
    );
};

const mapDispatchToProps = {
    getContractDataById,
    updateDataModelData,
    clearSuccessMsg,
    downloadSheet,
    getModelDataDropDown,
    downloadContractPDFAction,
    getEventByID,
    initiateAction,
    getMembersList,
    clearReduxDataOfCurrentComponent,
    updateContractAnnotations,
    getDataModelById,
    getAuditTrailsData,
    getOthersAuditTrailsData,
    getModelData,
    completeReviewAction,
    getDataModels,
    otherDocMove,
    supportingDocMove,
    getHistoryData,
    getWorkflow,
    getGroupsByMemberId, getNextRespondent,
    getNextTasks,
    reInitiateWorkflow,
    executeWorkFlow,
    executeWorkFlowReject,
    changeAssigneeRequest,
    addComment,
    rejectReviewAction,
    getGroups,
    fetchmasterDataForDataelementUsingRules,
    createDocumentTableData,
    getDocumentTablesDataById,
    updateDocumentTableData,
    deleteDocumentTableData,
    moveToDuplicates,
    getLineItemsTablesData,
    addNewEntriesByDataModel,
    createAmendment,
    getAmendments,
    createContractHierarchy,
    getContractHierarchys,
    deleteTreeElements,
    createNewDocumentPrompt,
    getDocumentQuestions,
    getDocumentQuestionsHierarchy,
    getSupportingDocuments,
    uploadSupportDocument,
    emailSendNotification,
    splitPDF,
    getDocumentHierarchys,
    updateDocHierarchys,
    getDocumentHierarchysV2,
    uploadAttachmentAmendmentTemplate,
    createAmendmentV2,
    getSubModelData,
    getPDFForOtherDoc,
    getPDFForAllOtherDoc,
    getPDFForSupportingDocuments,
    getCurrentStepRespondents,
    userActivityRecordEvent,
    uploadLITableExcel
};

const mapStateToProps = state => {
    return {
        action: state.action,
        formData: state.form,
        pagesData: state.pages.pages,
        PUBLIC_PATH: PUBLIC_PATH,
        dataModels: state.dataModels,
        appConfig: state.appConfig.app,
        members: state.appConfig.members,
        currentMember: state.appConfig.members,
        user: state.user,
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PDFComplexViewV4Component));